import axios from 'axios'

var Dominio = "http://api.infoassuf.com.br/";
if (document.location.hostname == "localhost"){
  Dominio = "http://localhost:8083/";
}

export default {

    ler(caminho, parametros) {
        return axios({
            method: 'post',
            headers:{
              'Content-Type':'application/x-www-form-urlencoded;charset=utf-8',
            },
            // Ex: http://api.aspeb.com.br/Segurado/RecuperarSelecao' 
            url: Dominio + caminho, 
            // Ex: {pesquisaid:'1234', pesquisacpf:'', pesquisanome:''}
            data : '='+JSON.stringify(parametros),
          });
    }
}
